/**
 * @generated SignedSource<<a87a1cec96504649ac1dabe888926561>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteChannelUserPayload",
    "kind": "LinkedField",
    "name": "deleteChannelUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedJoinedChannelId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteChannelUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteChannelUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5a55021babb4e5c6ac316837e2cb614",
    "id": null,
    "metadata": {},
    "name": "DeleteChannelUserMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteChannelUserMutation(\n  $input: DeleteChannelUserInput!\n) {\n  deleteChannelUser(input: $input) {\n    deletedId\n    deletedJoinedChannelId\n  }\n}\n"
  }
};
})();

node.hash = "95419cf5e4eee5c9a9d2c20a9ddd66e1";

export default node;
